var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.connection
    ? _c(
        "div",
        {
          staticClass: "text-container",
          on: {
            mouseover: function($event) {
              _vm.hover = true
            },
            mouseleave: function($event) {
              _vm.hover = false
            },
            click: function($event) {
              return _vm.$emit("click", _vm.connection.cb_uuid)
            }
          }
        },
        [
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.connection.cb_label
                  ? _vm.connection.cb_label
                  : _vm.connection.cb_id
              )
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2135de06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2135de06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectMenu/JoinCableMenu/JoinCableMenuItem.vue
// module id = null
// module chunks = 